export const MODAL_CONFIRMATION_STATE_DELAY = 7000;
